import React from 'react'
import { EditIcon } from '@chakra-ui/icons'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    Flex,
    Box,
    Input,
    ModalFooter,
    Button,
    Text,
    Icon,
} from '@chakra-ui/react'
import { format } from 'date-fns'
import { FiPrinter } from 'react-icons/fi'

import {
    ChatFieldsFragment,
    ChatMessageFieldsFragment,
    useGetMessagesByChatIdQuery,
} from '~graphql/generated/graphql'
import { useDebounce } from '~utils/hooks/use-debounce'
import { ExportPDFButton } from './export-pdf/export-button'
import MenuItem from '~components/shared/menu/menu-item'
import { FaPrint } from 'react-icons/fa6'
import { getClientFullName } from '~utils/helpers'

const DownloadMsgsModalButton: React.FC<{
    chat: ChatFieldsFragment
    messages: ChatMessageFieldsFragment[]
    canExport: boolean
}> = ({ chat, messages, canExport }) => {
    const [isOpen, setIsOpen] = React.useState(false)

    return (
        <>
            <Button
                size="xs"
                rounded="full"
                height="28px"
                px={3}
                variant="subtle"
                bg="white"
                _hover={{
                    bg: 'gray.50',
                }}
                _active={{
                    bg: 'gray.100',
                }}
                borderWidth={1}
                borderColor="gray.200"
                isDisabled={!canExport}
                onClick={() => setIsOpen(true)}
                leftIcon={<Icon as={FaPrint} />}
            >
                Download PDF
            </Button>
            <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Download PDF of Messages</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Flex>
                            <Text>
                                Exporting {messages.length} messages to PDF
                            </Text>
                        </Flex>
                    </ModalBody>
                    <ModalFooter justifyContent="space-between">
                        <Button mr={3} onClick={() => setIsOpen(false)}>
                            Close
                        </Button>
                        {isOpen && (
                            <ExportPDFButton
                                chat={chat}
                                documentTitle={
                                    'Messages with ' +
                                    getClientFullName(chat.client) +
                                    ' - ' +
                                    format(new Date(), 'PPPPpp')
                                }
                                messages={messages}
                            />
                        )}
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}

export default DownloadMsgsModalButton
